import { DEAL_ACTIVITY } from './dealActivityEvent';
import { LIST_OF_CALENDAR_EVENTS } from './listOfCalendarEvents';
import { CALENDAR_EVENT_NOTES } from './eventNotesList';
import { CALENDAR_ACCOUNT_OPTIONS } from './calendarAccountOptions';
import { CALENDAR_CONTACT_OPTIONS } from './calendarContactOptions';
import { CALENDAR_EVENTS_LISTING } from './calendarEventsListing';

import { ADD_EVENT_NOTE } from './addEventNote';
import { RE_DATE_EVENT_ACTIVITIES } from './reDateEventActivities';
import { COMPLETE_EVENT_ACTIVITIES } from './completeEventActivities';
import { MOVE_TO_TOMORROW_DATE_EVENT_ACTIVITIES } from './moveToTomorrowDateEventActivities';

export * from './types';
export * from './usaCalendar';
export * from './useCalendarFormOptions';

export const calendarApi = {
  dealActivity: DEAL_ACTIVITY,
  calendarEventNotes: CALENDAR_EVENT_NOTES,
  listOfCalendarEvents: LIST_OF_CALENDAR_EVENTS,
  calendarEventsListing: CALENDAR_EVENTS_LISTING,

  calendarAccountOptions: CALENDAR_ACCOUNT_OPTIONS,
  calendarContactOptions: CALENDAR_CONTACT_OPTIONS,

  addEventNote: ADD_EVENT_NOTE,
  reDate: RE_DATE_EVENT_ACTIVITIES,
  complete: COMPLETE_EVENT_ACTIVITIES,
  moveToTomorrow: MOVE_TO_TOMORROW_DATE_EVENT_ACTIVITIES,
};
